module.exports = __webpack_public_path__ + "static/media/Portrait-10219.2b839be6.jpg";